import React from 'react';

import Image from '~/src/components/image/Image';
import Link from '~/src/components/link/Link';
import {ImageFormat} from '~/src/utilities/constants/formats';

import {getContentUrl} from '~/src/utilities/helpers/link';

import css from './TeaserTopItem.module.scss';

interface Props {
    image?: any;
    titleHeader?: string;
    title?: string;
    url?: string;
    className?: string;
    onClick?: () => void;
}

const TeaserTopItem = ({image, titleHeader, title, url, className, onClick}: Props) => {
    const Wrapper = url ? Link : React.Fragment;

    return (
        <Wrapper href={url && getContentUrl(url)} onClick={onClick}>
            <article className={[className, url ? css.teaser : css.placeholder].join(' ')}>
                <div className={css.image}>{image && <Image {...image} promcolor={css.accentColor} format={ImageFormat.IMAGE_COVER} />}</div>
                <h3 className={css.header}>
                    <span className={css.titleHeader}>{titleHeader}</span>
                    <span className={css.title}>{title}</span>
                </h3>
            </article>
        </Wrapper>
    );
};

export default TeaserTopItem;
